import { asText } from '@prismicio/helpers';
import { PrismicRichText } from '@prismicio/react';
import Image from 'next/image';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fluidProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import { Label } from './BenefitsOverviewSlice';
import { TitleWrapper, Description } from './CompetingTalentSlice';
import { Section } from './WorkBenefitSlice';

import { fieldHasContent, transformProperties } from '@/src/domains/prismic/helpers';
import { desktopBreakpoint } from '@/src/domains/shared/breakpoints';
import { Name } from '@/src/views/G2GatedAsset/QuoteSlice';
import QuoteIcon from '@/src/views/G2GatedAsset/assets/quote-icon.svg';

export const SectionWrapper = styled(Section)`
  --textBgColor: #d6c5ff;
  --secondaryBgColor: #fbf9ff;

  && {
    text-align: center;
    font-family: var(--typography-fontBossa);
    background-color: var(--secondaryBgColor);

    ${TitleWrapper} {
      color: var(--primaryColor);
    }
  }
`;

export const Quote = styled(Description)`
  margin: 30px 0 10px 0;
  ${fluidProp('line-height', '24px', '34px')}

  span {
    background-color: var(--textBgColor);
    box-shadow: 5px 0 0 var(--textBgColor), -5px 0 0 var(--textBgColor);
    padding: 5px 0;

    ${desktopBreakpoint(css`
      box-shadow: 5px 0 0 var(--textBgColor), -5px 0 0 var(--textBgColor);
      padding: 5px 0;
    `)}
  }
`;

export const ContentWrapper = styled.div`
  text-align: left;
  max-width: 547px;

  ${desktopBreakpoint(css`
    text-align: center;
    margin: 0 auto;
  `)}
`;

export const QuoteWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  margin-top: 50px;

  ${desktopBreakpoint(css`
    flex-direction: column;
  `)}
`;

export const Position = styled(Name)`
  font-family: var(--typography-fontBrand);
  ${({ theme }) => theme.typography.titleMD}
  font-weight: 400;
`;

export function QuoteSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { label, title, illustration, quoteBold, quote, name, position } = primary;

  return (
    <SectionWrapper>
      <ContentContainer>
        {fieldHasContent(label) && <Label>{label}</Label>}
        {fieldHasContent(title) && (
          <TitleWrapper>
            <PrismicRichText field={title} />
          </TitleWrapper>
        )}
        <QuoteWrapper>
          <div>
            {illustration && (
              <Image
                src={illustration?.url}
                alt={illustration?.alt || ''}
                width={illustration?.dimensions.width}
                height={illustration?.dimensions.height}
                quality="100"
              />
            )}
            {fieldHasContent(name) && (
              <Name>
                <PrismicRichText field={name} />
              </Name>
            )}
            {fieldHasContent(position) && (
              <Position>
                <PrismicRichText field={position} />
              </Position>
            )}
          </div>
          <ContentWrapper>
            <QuoteIcon />
            {fieldHasContent(quoteBold) && fieldHasContent(quote) && (
              <Quote>
                <span>{asText(quoteBold)}</span>
                {asText(quote)}
              </Quote>
            )}
          </ContentWrapper>
        </QuoteWrapper>
      </ContentContainer>
    </SectionWrapper>
  );
}
